module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-supervisors panel panel-default"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activated == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 1
      }
    }
  }, [_vm._v("\n                Активные\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 0
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 0
      }
    }
  }, [_vm._v("\n                Деактивированные\n            ")])])]), _vm._v(" "), _c('list-supervisors', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 1),
      expression: "activated == 1"
    }],
    attrs: {
      "activated": "1"
    }
  }), _vm._v(" "), _c('list-supervisors', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 0),
      expression: "activated == 0"
    }],
    attrs: {
      "activated": "0"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29ea4cfb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29ea4cfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsSupervisors.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-29ea4cfb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsSupervisors.vue
// module chunks = 0